import './public-path';
import './bugsnag-init';

if (!window.console) {
  window.console = {
    log: function() {}
  };
}
if (!console.debug) {
  console.debug = console.log;
}


const ELEMENT_NODE = 1;
const TEXT_NODE = 3;


import c5_xhr from './util/c5_xhr';
import { getPlatformAccessToken, leaveToPlatform } from './util/platformAuth';
import { parsePlatformPath } from './util/platformRoutes';

import getElementClassList from './util/oldie/getElementClassList';
import setImmediate from './util/setImmediate';

import DisableWindowInteractionUtil from './util/tools/DisableWindowInteractionUtil';

import setCookie from './util/cookie/setCookie';
import getCookies from './util/cookie/getCookies';

import getEventKey from './util/oldie/getEventKey';
// import { Userpilot } from 'userpilot';
// import { initialize as initializePendo, TextCapture } from '@pendo/web-sdk';

require('./assets/css/login.css'); //.use();

window.localtime = +new Date;
window.servertime = +new Date;

window.getLiveTime = () => {
  return +new Date + (window.servertime - window.localtime);
};

window.c5_sessionid = null;

/* -------------------------------------------------------------------------- */
//var c5_div_cursor_refresh;


let cookies = getCookies();

document.addEventListener('DOMContentLoaded', () => {
  if (window.passwordReset) {
    return;
  }

  let doc = document;
  let docElem = doc.documentElement;

  if ('msOverflowStyle' in docElem.style) {
    docElem.className = 'iescroll';
  }

  window.c5scrollPaddingRight = (() => {
    let div = doc.createElement('div');
    div.style.overflow = 'scroll';
    div.style.width = div.style.height = '100px';

    docElem.appendChild(div);
    let scrollPaddingRight = 100 - div.clientWidth;
    //scrollPaddingBottom = 100 - div.clientHeight;
    docElem.removeChild(div);
    return scrollPaddingRight;
  })();

  // computes additional padding required for consistent client overflow width
  // only tests an exact style-hierarchy, each requires a separate test
  window.c5absoluteOverflowPaddingRight = (() => {
    let div1 = doc.createElement('div');
    div1.style.position = 'absolute';

    let div2 = doc.createElement('div');
    div2.style.overflow = 'scroll';
    div2.style.height = '100px';

    let div3 = doc.createElement('div');
    div3.style.width = '100px';
    div3.style.height = '200px';

    div2.appendChild(div3);
    div1.appendChild(div2);

    docElem.appendChild(div1);
    let pad = 100 - div2.clientWidth;
    docElem.removeChild(div1);
    return pad;
  })();





  let cookieOptions = {
    path: '/',
    maxAge: 365 * 24 * 60 * 60 * 1000,
    secure: true
  };

  // TODO: SYNCHRONIZE LANGUAGES.
  let langs = ['en', 'fr', 'sv', 'de', 'nl', 'da', 'ja', 'pt', 'es', 'cs', 'it', 'pl', 'sk', 'sr'];

  for (let i = 0; i < langs.length; i++) {
    let lang = langs[i];

    let elem = document.getElementById('switch-to-' + lang);
    if (elem) {
      elem.addEventListener('click', () => {
        setCookie('locale', lang, cookieOptions);
        location.reload();
      });
    }
  }


  /*c5_cursor_ref = document.createElement('div');
  let cursorRefStyle = c5_cursor_ref.style;
  cursorRefStyle.display = 'none';
  cursorRefStyle.position = 'fixed';
  cursorRefStyle.zIndex = 50001;
  cursorRefStyle.height = '100%';
  cursorRefStyle.width = '100%';
  cursorRefStyle.overflow = 'hidden';
  c5_cursor_ref.appendChild(document.createElement('div'));
  document.body.appendChild(c5_cursor_ref);*/

  document.getElementById('popups').addEventListener('mousewheel', (event) => {
    event.stopPropagation();
  });
});

/* -------------------------------------------------------------------------- */

/*window.c5_cursor_refresh = function() {
  var cursorRefStyle = c5_cursor_ref.style;
  cursorRefStyle.display = 'block';
  cursorRefStyle.scrollLeft = 1;
  cursorRefStyle.scrollLeft = 0;
  cursorRefStyle.display = 'none';

  c5_div_cursor_refresh.show();
  c5_div_cursor_refresh.scrollLeft(1);
  c5_div_cursor_refresh.scrollLeft(0);
  c5_div_cursor_refresh.hide();
};*/

/* -------------------------------------------------------------------------- */


document.addEventListener('DOMContentLoaded', function() {
  let forceSelectableNodeTypes = {
    INPUT: true,
    TEXTAREA: true,
    EMBED: true,
    OBJECT: true
  };

  function findClosestSelectable(node) {
    if (node) {
      if (node.nodeType === ELEMENT_NODE &&
          forceSelectableNodeTypes[node.nodeName]) {
        return node;
      }

      if (node.nodeType === TEXT_NODE) {
        node = node.parentNode;
      }

      while (node && node.nodeType === ELEMENT_NODE) {
        if (getElementClassList(node).contains('selectable')) {
          return node;
        }

        node = node.parentNode;
      }
    }

    return null;
  }

  function preventUnselectableNodeEvent(event) {
    if (!findClosestSelectable(event.target)) {
      event.preventDefault();
    }
  }

  function handleDocumentMouseDown(event) {
    if (findClosestSelectable(event.target)) {
      if (document.documentElement.style.cursor === 'default') {
        document.documentElement.style.cursor = 'text';

        // should listen for window blur events too!
        document.addEventListener('mouseup', handleDocumentMouseUp);
      }
    }
  }

  function handleDocumentMouseUp(event) {
    document.removeEventListener('mouseup', handleDocumentMouseUp);

    if (document.documentElement.style.cursor === 'text') {
      document.documentElement.style.cursor = 'default';
    }
  }

  document.addEventListener('dragstart', preventUnselectableNodeEvent);
  document.addEventListener('selectstart', preventUnselectableNodeEvent);
  document.addEventListener('mousedown', handleDocumentMouseDown);

  document.documentElement.style.cursor = 'default';


  // -------------------------------

  function handleDocumentKeyDown(event) {
    // TODO: should prevent for checkbox/radio/etc
    if (event.target && getEventKey(event) === 'Backspace') {
      if (!forceSelectableNodeTypes[event.target.nodeName] || event.target.readOnly) {
        event.preventDefault();
      }
    }
  }

  document.addEventListener('keydown', handleDocumentKeyDown);
});

function applyInput(rootNode) {
  let inputNode = rootNode.lastChild;
  let classList = getElementClassList(rootNode);

  function handleInputUpdate() {
    if (inputNode.value !== '') {
      classList.add('nonempty');
    } else {
      classList.remove('nonempty');
    }
  }

  function handleInputDeferredUpdate() {
    setImmediate(handleInputUpdate);
  }

  inputNode.addEventListener('keypress', (event) => {
    classList.remove('error');
    handleInputDeferredUpdate();
  });

  inputNode.addEventListener('change', handleInputUpdate);
  inputNode.addEventListener('update', handleInputUpdate);
  inputNode.addEventListener('keydown', handleInputDeferredUpdate);
  inputNode.addEventListener('paste', handleInputDeferredUpdate);

  inputNode.addEventListener('focus', (event) => {
    classList.add('focus');
  });

  inputNode.addEventListener('blur', (event) => {
    classList.remove('focus');
  });

  inputNode.update = handleInputUpdate;

  inputNode.error = function() {
    inputNode.value = '';
    classList.add('error');
    classList.remove('nonempty');
  };

  if (inputNode.value !== '') {
    classList.add('nonempty');
  }

  if (inputNode === document.activeElement) {
    classList.add('focus');
  }
}

let imageList = [];
let extras_preloaded = false;
let images_preloaded = false;
let authenticated = false;

c5_preload(window.images, () => {
  images_preloaded = true;
  c5_trylogin();
});


document.addEventListener('DOMContentLoaded', function() {

  if (window.passwordReset) {
    document.getElementById('action-gotologin1').addEventListener('click', () => {
      window.c5_block_source_node(document.getElementById('action-gotologin1'));
      window.c5_block_begin();
      location.href = '/';
    });

    document.getElementById('action-gotologin2').addEventListener('click', () => {
      window.c5_block_source_node(document.getElementById('action-gotologin1'));
      window.c5_block_begin();
      location.href = '/';
    });

    if (window.mode === 'expired') {
      document.getElementById('page-expired').style.display = 'block';
      return;
    }

    document.getElementById('page-entry').style.display = 'block';

    let inputPassword = document.getElementById('input-password');
    let inputPassword2 = document.getElementById('input-password2');

    applyInput(inputPassword.parentNode);
    applyInput(inputPassword2.parentNode);

    inputPassword.select();


    document.getElementById('action-submit').addEventListener('click', () => {
      document.getElementById('error-invalidpassword').style.display = 'none';
      document.getElementById('error-passwordnotequal').style.display = 'none';

      if (inputPassword.value.trim() === '' ||
          inputPassword.value.length < 8) {
        document.getElementById('error-invalidpassword').style.display = 'block';
        return;
      }

      if (inputPassword.value.trim() === '' ||
          inputPassword.value.length < 8 ||
          inputPassword.value !== inputPassword2.value) {
        inputPassword.value = '';
        inputPassword2.value = '';
        inputPassword.update();
        inputPassword2.update();
        document.getElementById('error-passwordnotequal').style.display = 'block';
        return;
      }

      window.c5_block_source_node(document.getElementById('action-submit'));

      window.c5_block_begin();

      let timezone = '';
      try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch {
      }

      c5_xhr({
          url: '/json/perform_password_reset',
        data: {
          key: window.key,
          password: inputPassword.value,
          timezone: timezone,
        }
      }, function(status, data) {
        if (status === 'success') {
          if (data && data.result === 'accepted') {
            setCookie('username', username, {
              path: '/',
              maxAge: 365 * 24 * 60 * 60 * 1000,
              secure: true
            });

            document.getElementById('page-entry').style.display = 'none';
            document.getElementById('page-performed').style.display = 'block';
          } else if (data.result === 'expired') {
            document.getElementById('page-entry').style.display = 'none';
            document.getElementById('page-expired').style.display = 'block';
          } else {
            alert('Unknown error, please try again!');
          }

          window.c5_block_end();
        } else {
          window.c5_block_end();

          alert('Unknown error, please try again!');
        }
      });
    });

    return;
  }

  document.getElementById('action-passwordreset').addEventListener('click', () => {
  });

  window.account = null;
  window.user = null;

  window.c5_event = null;
  window.c5_unload = [];
  window.c5_back = null;
  window.c5_locked = false;


  window.h_repeat = (n) => {
    let r = [];
    for (let i = 0; i < n; i++) {
      r.push(i);
    }
    return r;
  };


  window.c5_logging_out = false;

  if (window.c5mail_sessionid != null) {
    history.replaceState({
      sessionid: window.c5mail_sessionid,
      platformaccount: window.c5mail_platformaccount ?? null,
    }, '');
  } else if (window.c5mail_resumable_sessionid != null && (history.state === null || typeof history.state !== 'object' || history.state.sessionid == null)) {
    // The session the browser last used, which the server offers on a page's URL of a session from the platform
    // (login_platform_page_action), for a tab without its own: a new tab. A reload keeps the tab's.
    history.replaceState({
      sessionid: window.c5mail_resumable_sessionid,
      platformaccount: window.c5mail_platformaccount,
    }, '');
  }

  if (history.state !== null) {
    if (typeof history.state === 'object') {
      if (history.state.sessionid != null) {
        window.c5_block_begin();

        document.getElementById('content').innerHTML = '';

        window.localtime = +new Date;
        window.servertime = +new Date;

        // A session from the platform resumes only with the platform's access token, and ends with the platform's
        let platformAccount = history.state.platformaccount;

        // A session from the platform that can't resume goes to the platform's login, without the session the browser
        // offers on a page's URL (lastsessionid), so that it isn't offered again
        let leavePlatformSession = () => {
          setCookie('lastsessionid', '', {secure: true, path: '/', maxAge: 0, sameSite: 'none'});
          leaveToPlatform();
        };

        let authenticate = (extraData) => {
          c5_xhr({
            url: '/json/authenticate',
            data: {
              session_key: history.state.sessionid,
              fpversion: '(null)',
              ...extraData,
            }
          }, function(status, data) {
            if (status === 'success' && data && data.result === 'accepted') {
              c5mail_auth_ok(data);
              window.c5_block_end();
            } else if (platformAccount != null) {
              leavePlatformSession();
            } else {
              history.replaceState(null, '');
              location.reload();
            }
          });
        };

        if (platformAccount != null) {
          window.c5platformaccount = platformAccount;

          // As the view does after the SSO, for a reload, which the server serves as the login page
          document.body.className = 'c5-style-platform';

          getPlatformAccessToken(platformAccount.platform_id).then((token) => {
            if (token === null) {
              leavePlatformSession();
              return;
            }

            authenticate({platformtoken: token});
          }, () => {
            leavePlatformSession();
          });
        } else {
          authenticate({});
        }

        return;
      }
    }
  }

  // A page's URL of a session from the platform, without a session here: the platform's login, instead of this one
  if (parsePlatformPath(location.pathname) !== null) {
    window.c5_block_begin();

    document.getElementById('content').innerHTML = '';
    document.body.className = 'c5-style-platform';

    leaveToPlatform();
    return;
  }


  {

    {
      document.getElementById('action-passwordreset').addEventListener('click', () => {
        document.getElementById('page-login').style.display = 'none';
        document.getElementById('page-passwordreset').style.display = 'block';
        document.getElementById('subpage-passwordreset-entry').style.display = 'block';
        document.getElementById('subpage-passwordreset-ratelimit').style.display = 'none';
        document.getElementById('subpage-passwordreset-sent').style.display = 'none';
        inputPasswordResetEmailaddress.value = inputUsername.value;
        inputPasswordResetEmailaddress.update();
        inputPasswordResetEmailaddress.select();
      });
    }

    {
      document.getElementById('action-backtologin').addEventListener('click', () => {
        document.getElementById('page-login').style.display = 'block';
        document.getElementById('page-passwordreset').style.display = 'none';
        document.getElementById('subpage-passwordreset-entry').style.display = 'none';
        document.getElementById('subpage-passwordreset-ratelimit').style.display = 'none';
        document.getElementById('subpage-passwordreset-sent').style.display = 'none';
        inputUsername.select();
      });
    }

    let inputPasswordResetEmailaddress = document.getElementById('input-passwordreset-emailaddress');
    applyInput(inputPasswordResetEmailaddress.parentNode);

    document.getElementById('action-passwordreset-submit').addEventListener('click', () => {

      if (!inputPasswordResetEmailaddress.value.includes('@')) {
        document.getElementById('passwordreset-error-invalidemailaddress').style.display = 'block';
        return;
      }

      window.c5_block_source_node(document.getElementById('action-passwordreset-submit'));

      window.c5_block_begin();

      c5_xhr({
        url: '/json/send_password_reset',
        data: {
          username: inputPasswordResetEmailaddress.value.trim(),
          locale: window.locale,
        }
      }, function(status, data) {
        window.c5_block_end();
        if (status === 'rate_limit') {
          document.getElementById('subpage-passwordreset-entry').style.display = 'none';
          document.getElementById('subpage-passwordreset-ratelimit').style.display = 'block';
        } else if (status === 'success') {
          if (data && data.result === 'accepted') {
            document.removeEventListener('keydown', handleEnterKey);
            document.getElementById('subpage-passwordreset-entry').style.display = 'none';
            document.getElementById('subpage-passwordreset-sent').style.display = 'block';
          } else {
            alert('Unknown error, please try again!');
          }
        } else {
          alert('Unknown error, please try again!');
        }
      });
    });


    let inputUsername = document.getElementById('input-username');
    let inputPassword = document.getElementById('input-password');

    applyInput(inputUsername.parentNode);
    applyInput(inputPassword.parentNode);

    let handleEnterKey = function(event) {
      if (window.c5_block_is()) {
        return;
      }

      if (getEventKey(event) === 'Enter') {
        event.preventDefault();
        if (document.getElementById('page-login').style.display === 'block') {
          document.getElementById('action-login').click();
        }
        if (document.getElementById('subpage-passwordreset-entry').style.display === 'block') {
          document.getElementById('action-passwordreset-submit').click();
        }
      }
    };

    document.addEventListener('keydown', handleEnterKey);

    document.getElementById('action-login').addEventListener('click', () => {

      if (inputUsername.value.trim() === '') {
        inputUsername.value = '';
        inputUsername.update();
      }
      if (inputPassword.value.trim() === '') {
        inputPassword.value = '';
        inputPassword.update();
      }

      if (inputUsername.value === '') {
        inputUsername.select();
        return;
      }
      if (inputPassword.value === '') {
        inputPassword.select();
        return;
      }

      window.c5_block_source_node(document.getElementById('action-login'));

      window.c5_block_begin();


      /*if (hasIntlSupport) {
        window.browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      if (!window.browserTimezone) {
        window.browserTimezone = require('.//jstz-1.0.4.min').jstz.determine().name();
      }*/


      window.localtime = +new Date;
      window.servertime = +new Date;
      c5_xhr({
        url: '/json/authenticate',
        data: {
          username: inputUsername.value,
          password: inputPassword.value,
          fpversion: '(null)',
        }
      }, function(status, data) {
        if (status === 'success') {
          if (data && data.result === 'accepted') {
            document.removeEventListener('keydown', handleEnterKey);

            c5mail_auth_ok(data);
          } else {
            inputPassword.error();
            inputPassword.select();
          }

          window.c5_block_end();
        } else {
          window.c5_block_end();

          alert('Unknown error, please try again!');
        }
      });
    });


    if (cookies.username) {
      inputUsername.value = cookies.username;
    }
    inputUsername.update();
    inputUsername.select();
  }
});

function c5_trylogin() {
  if (!authenticated) {
    return;
  }
  if (!images_preloaded) {
    return;
  }
  if (!extras_preloaded) {
    return;
  }
  if (!window.c5mailstart) {
    return;
  }

  clearInterval(window.trylogininterval);

  // window.addEventListener('keydown', (event) => {
  //   if (event.which === 116 && !(event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey ||
  //       event.which === 82 && (event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey) {
  //     /* block F5 and CTRL-R */
  //     event.preventDefault();
  //   }
  // });

  window.addEventListener('beforeunload', (event) => {
    if (window.c5_nounload) return;

    if (window.c5_logging_out) {
      return;
    }
    if (window.c5_locked) {
      event.returnValue = '';
      return;
    }
  });

  // window.addEventListener('unload', (event) => {
  //   if (window.c5_nounload) return;

  //   window.c5_block_begin();

  //   c5_xhr({
  //     url: '/logout',
  //     data: {
  //       sso: window.c5mail_sso ? 1 : 0,
  //       sessionid: window.c5_sessionid
  //     }
  //   });
  // });

  window.c5mailstart();
  window.c5_block_end();
}

function c5_preload(images, callback) {
  let counter = 0;

  for (let path in images) {
    if (images.hasOwnProperty(path)) {
      counter += images[path].length;
    }
  }

  if (counter === 0) {
    callback();
  }

  for (let path in images) {
    if (images.hasOwnProperty(path)) {
      ((path) => {
        images[path].forEach((name) => {
          let image = new Image();
          image.src = path + name;
          function handleLoadError() {
            counter--;
              if (counter === 0) {
                callback();
              }
          }
          image.addEventListener('load', handleLoadError);
          image.addEventListener('error', handleLoadError);

          imageList.push(image);
        });
      })(path);
    }
  }

  setTimeout(() => {
    if (counter > 0) {
      counter = -1;
      callback();
    }
  }, 3000);
}

function c5mail_auth_ok(data) {
  window.c5_block_begin();

  c5_preload(data.preload, () => {
    extras_preloaded = true;
    c5_trylogin();
  });

  window.servertime = data.time;

  require.ensure([
    'react',
    'react-dom',
    'moment',
    'moment-timezone/moment-timezone.js',
    'intl-messageformat'
  ], require => {

    if (data.master === true) {
      require.ensure([], require => {
        window.c5_adminuser = data.adminUser;
        window.c5username = '#' + data.adminUser.username;
        window.c5_sessionid = data.sessionid;
        authenticated = true;

        history.replaceState({
          sessionid: window.c5_sessionid,
        }, '');

        setCookie('username', c5username, {
          path: '/',
          maxAge: 365 * 24 * 60 * 60 * 1000,
          secure: true
        });
        setCookie('locale', 'en', {
          path: '/',
          maxAge: 365 * 24 * 60 * 60 * 1000,
          secure: true
        });
        setCookie('lastlocale', 'en', {
          path: '/',
          maxAge: 365 * 24 * 60 * 60 * 1000,
          secure: true
        });

        require('.//login-admin');
      }, 'admin');
    } else {

      window.activatetracking = 0;
      if (!data.admin) {
        window.activatetracking = 1;
        // initializePendo({
        //   publicAppId: '8bb79b3d-8573-424c-b636-d4ce9478c5d4',
        //   env: 'eu',
        //   visitor: {
        //     id: data.user.userid,
        //     username: data.user.username,
        //   },
        // });
        // Userpilot.initialize(window.c5mail_userpilot_key);

        // Userpilot.identify(data.user.userid, {
        //   name: data.user.username,
        //   email: data.user.username,
        //   bug_fixed: 'true',
        // });
      }

      if (!data.admin) {
        setCookie('username', data.user.username, {
          path: '/',
          maxAge: 365 * 24 * 60 * 60 * 1000,
          secure: true
        });
        setCookie('locale', data.user.locale, {
          path: '/',
          maxAge: 365 * 24 * 60 * 60 * 1000,
          secure: true
        });
        setCookie('lastlocale', data.user.locale, {
          path: '/',
          maxAge: 365 * 24 * 60 * 60 * 1000,
          secure: true
        });
      }

      window.c5username = data.user.username;
      window.c5mainusermigrate = data.mainusermigrate;
      window.c5fromplatform = data.fromplatform;

      require.ensure([], require => {
        window.user = data.user;
        window.selectorEntryObjectId = data.entryObjectId;
        window.selectorObjectMap = data.objectMap;
        window.selectorFavorites = data.favorites;
        window.selectorSearchText = '';

        // Skip only organization and first access-group
        for (let i = 0; i < 2; i++) {
          let object = window.selectorObjectMap[window.selectorEntryObjectId];
          if (object.type === 'account' || object.childObjectIds.length !== 1) {
            break;
          }

          window.selectorEntryObjectId = object.childObjectIds[0]
        }

        let rootObject = window.selectorObjectMap[window.selectorEntryObjectId]
        if (rootObject.type === 'account') {
          window.hasMultipleAccounts = false;
          window.selectorOnlyAccountId = rootObject.id;
        } else {
          window.hasMultipleAccounts = true;
        }

        // A session from the platform is for the one account the platform sent the user into
        if (data.fromplatform) {
          window.hasMultipleAccounts = false;
          window.selectorOnlyAccountId = window.c5platformaccount.accountid;
        }

        window.c5_sessionid = data.sessionid;

        let resetstate = false;
        if (history.state != null) {
          if (history.state.sessionid !== window.c5_sessionid) {
            resetstate = true;
          }
        } else {
          resetstate = true;
        }

        if (resetstate) {
          history.replaceState({
            sessionid: window.c5_sessionid,
            platformaccount: window.c5platformaccount ?? null,
          }, '');
        }

        authenticated = true;

        window.trylogininterval = setInterval(() => {
          c5_trylogin();
        }, 10);

        require('.//login-app');
      }, 'app');
    }
  }, 'app-vendor');
}

/* -------------------------------------------------------------------------- */

/*c5.busy = {};
c5.busy.navigate = c5_block_navigate;
c5.busy.source = c5_block_source;
c5.busy.reset = c5_block_reset;
c5.busy.begin = c5_block_begin;
c5.busy.end = c5_block_end;*/
// c5_block_request !!!

/*
function c5_busy_source_begin($source) {}
function c5_busy_source_end() 7}
function c5_busy_begin_popup($popup) {}
function c5_busy_end_popup($popup) {}
function c5_busy_begin_window() {}
function c5_busy_end_window() {}

function _c5_busy_begin() {}
function _c5_busy_end() {}
*/


/*
window.UserInterface = {
  waitSync(elem) {
    c5_block_begin();
    if (elem) {
      c5_block_source(elem);
    }
    return c5_block_end;
  },

  waitAsync() {
    c5_block_enableclick();
    c5_block_begin();
    return c5_block_end;
  },

  //ready() {
  //  c5_block_reset();
  //}
};
*/

let c5_block_counter = 0;
let c5_block_callbacks = [];
let c5_block_clickthrough = false;
let c5_block_disabledinteraction = false;
/*
window._c5_block_handler = function(event) {
  event.preventDefault();
  event.stopPropagation();

  if (event.stopImmediatePropagation) {
    event.stopImmediatePropagation();
  }
};*/

window.c5_block_is = function() {
  return c5_block_counter > 0;
};

window.c5_block_is_preventing = function() {
  return c5_block_counter > 0 && !c5_block_clickthrough;
};

window.c5_block_enableclick = function() {
  c5_block_clickthrough = true;
};

window.c5_block_source_node = function(elem) {
  if (!elem) {
    if (__DEV__) {
      console.error('INVALID BLOCK SOURCE NODE');
    }
    return;
  }

  getElementClassList(elem).add('working');

  c5_block_callbacks.push(() => {
    getElementClassList(elem).remove('working');
  });
};

window.c5_block_callback = function(cb) {
  c5_block_callbacks.push(cb);
};

window.c5_block_reset = function() {
  if (c5_block_disabledinteraction) {
    DisableWindowInteractionUtil.pop();
    c5_block_disabledinteraction = false;
  }

  c5_block_clickthrough = false;

  if (c5_block_counter === 0) {
    c5_block_callbacks.length = 0;
    return;
  }

  c5_block_counter = 0;
  /*
  document.removeEventListener('mousedown', _c5_block_handler);
  document.removeEventListener('mouseup', _c5_block_handler);
  document.removeEventListener('keydown', _c5_block_handler);
  document.removeEventListener('keypress', _c5_block_handler);
  document.removeEventListener('keyup', _c5_block_handler);

  document.documentElement.style.cursor = 'default';


  c5_div_block_input.style.display = 'none';*/



  document.documentElement.style.cursor = 'default';

  c5_block_callbacks.forEach((callback) => callback());
  c5_block_callbacks.length = 0;
};

window.c5_block_begin = function() {
  if (c5_block_counter === 0) {
    document.documentElement.style.cursor = 'progress';

    if (!c5_block_clickthrough && !c5_block_disabledinteraction) {
      c5_block_disabledinteraction = true;
      DisableWindowInteractionUtil.push();
      /*document.addEventListener('mousedown', _c5_block_handler);
      document.addEventListener('mouseup', _c5_block_handler);
      document.addEventListener('keydown', _c5_block_handler);
      document.addEventListener('keypress', _c5_block_handler);
      document.addEventListener('keyup', _c5_block_handler);

      c5_div_block_input.style.display = 'block';

      let activeNode = document.activeElement;
      if (activeNode && activeNode.blur) {
        activeNode.blur();
      }*/
    }
  }

  c5_block_counter++;
};

window.c5_block_end = function() {
  if (c5_block_counter === 0) {
    return;
  }

  c5_block_counter--;

  if (c5_block_counter === 0) {
    /*document.documentElement.style.cursor = 'default';

    document.removeEventListener('mousedown', _c5_block_handler);
    document.removeEventListener('mouseup', _c5_block_handler);
    document.removeEventListener('keydown', _c5_block_handler);
    document.removeEventListener('keypress', _c5_block_handler);
    document.removeEventListener('keyup', _c5_block_handler);

    c5_div_block_input.style.display = 'none';*/



    document.documentElement.style.cursor = 'default';

    if (c5_block_disabledinteraction) {
      c5_block_disabledinteraction = false;
      DisableWindowInteractionUtil.pop();
    }

    c5_block_clickthrough = false;


    c5_block_callbacks.forEach((callback) => callback());
    c5_block_callbacks.length = 0;
  }
};

/* -------------------------------------------------------------------------- */
/*
window.c5_selection_get = function(elem) {
  let start = 0, end = 0;

  if ('selectionStart' in elem) {
    start = elem.selectionStart;
    end = elem.selectionEnd;
  } else {
    // IE 7-8
    let range = document.selection.createRange();

    if (range && range.parentElement() === elem) {
      let len = elem.value.length;
      let value = elem.value.replace(/\r\n/g, '\n');

      let textrange = elem.createTextRange();
      textrange.moveToBookmark(range.getBookmark());

      let endrange = elem.createTextRange();
      endrange.collapse(false);

      if (textrange.compareEndPoints('StartToEnd', endrange) > -1) {
        start = end = len;
      } else {
        start = -textrange.moveStart('character', -len);
        start += value.slice(0, start).split('\n').length - 1;

        if (textrange.compareEndPoints('EndToEnd', endrange) > -1) {
          end = len;
        } else {
          end = -textrange.moveEnd('character', -len);
          end += value.slice(0, end).split('\n').length - 1;
        }
      }
    }
  }

  return {
    start: start,
    end: end
  };
}

window.c5_selection_set = function(elem, start, end) {
  if ('selectionStart' in elem) {
    elem.selectionStart = start;
    elem.selectionEnd = end;
    elem.focus();
  } else {
    // IE 7-8
    let inputRange = elem.createTextRange();
    inputRange.moveStart('character', start);
    inputRange.collapse();
    inputRange.moveEnd('character', end - start);
    inputRange.select();
  }
}
*/
